module.exports = __webpack_public_path__ + "img/VU.7713db5b.svg";